export default function addContext(Component, contextTypes) {
    Component.contextTypes = Component.contextTypes || {};
    Object.assign(Component.contextTypes, contextTypes);

    return Component;
}



// WEBPACK FOOTER //
// ./src/component-helpers/addContext.js